import React, { useState, useEffect } from 'react';
import { PublicLayout } from '../../components/layout/PublicLayout';
import { leadershipAPI } from '../../lib/api';
import { User } from '@phosphor-icons/react';

const GRAND_PRIOR_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/7sopmjll_654a5cab-82f1-4a3a-b338-845a9cfc55a5.jpeg";
const GRAND_CHANCELLOR_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/uxqnufxy_b6bb0d46-4876-46ce-a56f-7c4f50b7bcb0.jpeg";
const GRAND_COMMANDER_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/avtmtrje_8449A5DE-1D10-4836-8116-4C39C32B3945.png";
const DEPUTY_GRAND_COMMANDER_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/3dact5sl_e6d12a12-f5eb-463a-a9b0-7d9849fbae56.jpeg";
const SECRETARY_GENERAL_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/hvcpne26_14CB5E3B-8AF9-44E6-82E0-8E2951E5993F.png";
const GRAND_TREASURER_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/o06zkt0g_CC4B15BA-C4D3-4D5B-974C-1287BB0AC493.png";
const DEPUTY_GRAND_TREASURER_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/rrdgrqzg_3CFDB350-215D-47D1-9E2E-7CA3A8A012E5_63D5C534-DE0A-45D0-B8BD-F1D3913944FE.jpeg";
const GRAND_HERALD_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/hgckjsyu_d2f21c6a-26d0-468b-bdf1-c799a886e135.jpeg";
const CHIEF_INTELLIGENCE_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/55kgmel3_a42d2682-e54b-4444-97d0-8d1ee5126dac.jpeg";
const COMMUNICATIONS_OFFICER_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/v3q6ga2n_7D4D19C4-D4ED-4FC0-9F58-115AAFD0E7BA_15E77F8D-3D38-4E28-BF86-87C554CF9A26.jpeg";
const SECURITY_SECRETARY_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/5e1j8uco_F74A9D2B-AFDD-457D-9E29-10C59E2E8F85_54D25ED4-1C2B-4ED8-950A-06E40D1F1D88.jpeg";
const DEPUTY_INTEL_OFFICER_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/cjteuy5y_7D776892-10AE-4B0B-814C-BA49AF0FEB5D_B52CF7F3-69C3-4A73-A80B-BBCAA6AF75DB.jpeg";
const SENIOR_COUNCILOR_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/xgtff9rw_497D0076-4C95-4FF8-9744-EAFD3B58EA6C_88DD8148-9EFA-42FD-B05A-BCABEB2F96C2.jpeg";
const DEPUTY_SECRETARY_GENERAL_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/1g8ty79i_A0C0322A-FFF8-42E2-ABA2-5429489B2EDE_EA13B3F1-18AA-471F-9D1C-5E94E8C51886.jpeg";
const CHIEF_OPERATIONS_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/jq261cau_c5e11ada-27e8-4769-a7ba-b1d2e39a9c9f.jpeg";
const GRAND_AMBASSADOR_PHOTO = "https://customer-assets.emergentagent.com/job_chivalric-office/artifacts/esv3hcpd_B91939EB-B355-4284-8486-A34769B867A8_593FBAE4-5D63-48DA-BB28-CACCFF7777F2.jpeg";

const defaultLeadership = [
  {
    id: '1',
    name: 'Grand Prior Sir Aaron Alonzo, GPKT, GCSG',
    title: 'Grand Prior & Grand Magisterial Legate',
    position: 'Grand Prior of the Caribbean',
    bio: 'The Grand Prior serves as the supreme head of the Grand Priory, representing the Order throughout the Caribbean region and serving as Grand Magisterial Legate to the Grand Magisterium.',
    credentials: [
      'Knight Grand Cross of Saint Gregory the Great',
      'Member of the College of Papal Knights',
      'Grand Magisterial Legate of the Grand Magisterium SCMOTH 1804',
      'Grand Prior of the Caribbean',
      'Knight Grand Cross SCMOTH 1804'
    ],
    image_url: GRAND_PRIOR_PHOTO,
    order: 1
  },
  {
    id: '2',
    name: 'Sir Keiron Regis GCKT',
    title: 'Grand Chancellor',
    position: 'Grand Chancellor',
    bio: 'The Grand Chancellor serves as the chief administrative officer, overseeing the official records, correspondence, and diplomatic affairs of the Grand Priory.',
    credentials: [
      'Grand Officer of the Caribbean Grand Priory SCMOTH 1804',
      'Knight Grand Cross SCMOTH 1804'
    ],
    image_url: GRAND_CHANCELLOR_PHOTO,
    order: 2
  },
  {
    id: '3',
    name: 'Sir Ronnie Lesaldo GCKT',
    title: 'Grand Commander',
    position: 'Grand Commander',
    bio: 'The Grand Commander leads the military and ceremonial aspects of the Order, ensuring proper protocol and discipline among the knights.',
    credentials: [
      'Grand Officer of the Caribbean Grand Priory SCMOTH 1804',
      'Chairman of the Security Council',
      'Knight Grand Cross SCMOTH 1804'
    ],
    image_url: GRAND_COMMANDER_PHOTO,
    order: 3
  },
  {
    id: '4',
    name: 'Sir Alva Shockness GCKT',
    title: 'Deputy Grand Commander',
    position: 'Deputy Grand Commander',
    bio: 'The Deputy Grand Commander assists the Grand Commander in all military and ceremonial duties, serving as second-in-command of the Order\'s operational functions.',
    credentials: [
      'Grand Officer of the Caribbean Grand Priory SCMOTH 1804',
      'Vice Chairman of the Security Council',
      'Knight Grand Cross SCMOTH 1804'
    ],
    image_url: DEPUTY_GRAND_COMMANDER_PHOTO,
    order: 4
  },
  {
    id: '5',
    name: 'Sir Samuel Wilson GCKT',
    title: 'Grand Secretary General',
    position: 'Grand Secretary General',
    bio: 'The Grand Secretary General maintains all official records, manages membership documentation, and oversees the administrative operations of the Grand Priory.',
    credentials: [
      'Grand Officer of the Caribbean Grand Priory SCMOTH 1804',
      'Knight Grand Cross SCMOTH 1804'
    ],
    image_url: SECRETARY_GENERAL_PHOTO,
    order: 5
  },
  {
    id: '14',
    name: 'Dame Eudiane Garcia GCKT',
    title: 'Deputy Grand Secretary General / Prefect',
    position: 'Deputy Grand Secretary General / Prefect',
    bio: 'The Deputy Grand Secretary General assists in all administrative duties and serves as Prefect, supporting the Grand Secretary General in managing the Order\'s records and correspondence.',
    credentials: [
      'Grand Officer of the Caribbean Grand Priory SCMOTH 1804',
      'Dame Grand Cross SCMOTH 1804'
    ],
    image_url: DEPUTY_SECRETARY_GENERAL_PHOTO,
    order: 6
  },
  {
    id: '6',
    name: 'Sir Jason Francis GCKT',
    title: 'Grand Treasurer',
    position: 'Grand Treasurer',
    bio: 'The Grand Treasurer manages all financial matters of the Grand Priory, including dues, donations, and charitable disbursements.',
    credentials: [
      'Grand Officer of the Caribbean Grand Priory SCMOTH 1804',
      'Knight Grand Cross SCMOTH 1804'
    ],
    image_url: GRAND_TREASURER_PHOTO,
    order: 7
  },
  {
    id: '7',
    name: 'Sir Aaron Dallaway GCKT',
    title: 'Deputy Grand Treasurer / Prefect / Councilor - Security Council',
    position: 'Deputy Grand Treasurer / Prefect / Councilor - Security Council',
    bio: 'The Deputy Grand Treasurer assists in financial management while also serving as Prefect and Councilor on the Security Council.',
    credentials: [
      'Grand Officer of the Caribbean Grand Priory SCMOTH 1804',
      'Knight Grand Cross SCMOTH 1804'
    ],
    image_url: DEPUTY_GRAND_TREASURER_PHOTO,
    order: 8
  },
  {
    id: '16',
    name: 'Sir Bobby Taylor GCKT',
    title: 'Grand Magisterial Ambassador',
    position: 'Grand Magisterial Ambassador',
    bio: 'The Grand Magisterial Ambassador represents the Grand Priory in diplomatic relations with the Grand Magisterium, other Orders, institutions, and international bodies.',
    credentials: [
      'Grand Officer of the Caribbean Grand Priory SCMOTH 1804',
      'Knight Grand Cross SCMOTH 1804'
    ],
    image_url: GRAND_AMBASSADOR_PHOTO,
    order: 9
  },
  {
    id: '8',
    name: 'Sir Trevor Alexander GCKT',
    title: 'Grand Herald',
    position: 'Grand Herald',
    bio: 'The Grand Herald oversees all ceremonial protocols, processions, and the proper display of heraldic symbols and regalia of the Order.',
    credentials: [
      'Grand Officer of the Caribbean Grand Priory SCMOTH 1804',
      'Knight Grand Cross SCMOTH 1804'
    ],
    image_url: GRAND_HERALD_PHOTO,
    order: 10
  },
  {
    id: '9',
    name: 'Brother Shanon Lewis',
    title: 'Acting Communications Officer',
    position: 'Acting Communications Officer',
    bio: 'The Communications Officer manages all internal and external communications, including media relations and public announcements.',
    credentials: [
      'Brother Novice SCMOTH 1804'
    ],
    image_url: COMMUNICATIONS_OFFICER_PHOTO,
    order: 10
  },
  {
    id: '10',
    name: 'Sergeant Anthony Sandy SGT',
    title: 'Chief Intelligence Officer / Security Council',
    position: 'Chief Intelligence Officer / Security Council',
    bio: 'The Chief Intelligence Officer leads the Security Council\'s intelligence operations, ensuring the safety and integrity of the Order.',
    credentials: [
      'Member of the Security Council',
      'Sergeant SCMOTH 1804'
    ],
    image_url: CHIEF_INTELLIGENCE_PHOTO,
    order: 11
  },
  {
    id: '12',
    name: 'Sergeant Joel Blaize SGT',
    title: 'Deputy Chief Intelligence Officer / Security Council',
    position: 'Deputy Chief Intelligence Officer / Security Council',
    bio: 'The Deputy Chief Intelligence Officer assists in all intelligence and security matters, serving as second-in-command of intelligence operations.',
    credentials: [
      'Member of the Security Council',
      'Sergeant SCMOTH 1804'
    ],
    image_url: DEPUTY_INTEL_OFFICER_PHOTO,
    order: 12
  },
  {
    id: '11',
    name: 'Sergeant Deniece Glasgow SGT',
    title: 'Secretary / Security Council',
    position: 'Secretary / Security Council',
    bio: 'The Secretary of the Security Council maintains records of all security proceedings and coordinates administrative functions of the Council.',
    credentials: [
      'Member of the Security Council',
      'Sergeant SCMOTH 1804'
    ],
    image_url: SECURITY_SECRETARY_PHOTO,
    order: 13
  },
  {
    id: '15',
    name: 'Sergeant Sydney Lynch SGT',
    title: 'Chief of Operations / Security Council',
    position: 'Chief of Operations / Security Council',
    bio: 'The Chief of Operations oversees all operational activities of the Security Council, coordinating security measures and logistics.',
    credentials: [
      'Member of the Security Council',
      'Sergeant SCMOTH 1804'
    ],
    image_url: CHIEF_OPERATIONS_PHOTO,
    order: 14
  },
  {
    id: '13',
    name: 'Sergeant Jason Ash SGT',
    title: 'Senior Councilor / Security Council',
    position: 'Senior Councilor / Security Council',
    bio: 'The Senior Councilor serves as an advisory member of the Security Council, providing counsel on security and strategic matters.',
    credentials: [
      'Member of the Security Council',
      'Sergeant SCMOTH 1804'
    ],
    image_url: SENIOR_COUNCILOR_PHOTO,
    order: 15
  }
];

const LeadershipPage = () => {
  const [leadership, setLeadership] = useState(defaultLeadership);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLeadership = async () => {
      try {
        const response = await leadershipAPI.getAll();
        if (response.data && response.data.length > 0) {
          setLeadership(response.data.sort((a, b) => (a.order || 0) - (b.order || 0)));
        }
      } catch (error) {
        console.log('Using default leadership data');
      } finally {
        setLoading(false);
      }
    };
    fetchLeadership();
  }, []);

  return (
    <PublicLayout>
      {/* Header */}
      <section className="py-20 bg-[#1A1614] text-center" data-testid="leadership-header">
        <p className="text-overline mb-4">Officers of the Order</p>
        <h1 className="font-heading text-4xl sm:text-5xl text-white mb-4">
          Leadership
        </h1>
        <p className="text-[#8A847A] max-w-2xl mx-auto px-4">
          The Grand Officers who guide and govern the Grand Priory of the Caribbean
        </p>
      </section>

      {/* Leadership Grid */}
      <section className="py-16 bg-[#F5F2EB]" data-testid="leadership-grid">
        <div className="max-w-4xl mx-auto px-4">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="spinner" />
            </div>
          ) : (
            <div className="space-y-6">
              {/* All Officers - Same Format, Stacked Vertically */}
              {leadership.map((leader) => (
                <div 
                  key={leader.id}
                  className="bg-white border border-[#D8D2C4] p-8 card-hover"
                  data-testid={`leader-card-${leader.id}`}
                >
                  <div className="flex flex-col md:flex-row items-center gap-8">
                    <div className="w-48 h-48 flex-shrink-0 bg-[#F5F2EB] overflow-hidden">
                      {leader.image_url ? (
                        <img src={leader.image_url} alt={leader.name} className="w-full h-full object-cover object-top" />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center text-[#8A847A]">
                          <User size={64} weight="thin" />
                        </div>
                      )}
                    </div>
                    <div className="flex-1 text-center md:text-left">
                      <p className="text-overline text-xs mb-2">{leader.title}</p>
                      <h3 className="font-heading text-2xl text-[#1A1614] mb-3">{leader.name}</h3>
                      {leader.bio && (
                        <p className="text-[#4A453E] leading-relaxed mb-3 italic">{leader.bio}</p>
                      )}
                      {leader.credentials && leader.credentials.length > 0 && (
                        <ul className="space-y-1">
                          {leader.credentials.map((credential, idx) => (
                            <li key={idx} className="text-sm text-[#4A453E]">
                              {credential}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Grand Officers Description */}
      <section className="py-16 bg-white" data-testid="leadership-description">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="font-heading text-3xl text-[#1A1614] mb-6 text-center">
            The Grand Chapter
          </h2>
          <p className="text-[#4A453E] leading-relaxed text-center">
            The Grand Chapter, composed of the Grand Officers, serves as the governing body 
            of the Grand Priory. Under the leadership of the Grand Prior, these officers 
            ensure the proper administration, governance, and spiritual direction of the 
            Order throughout the Caribbean jurisdiction.
          </p>
        </div>
      </section>
    </PublicLayout>
  );
};

export default LeadershipPage;
